import { render } from "./Account.vue?vue&type=template&id=82d55638&ts=true"
import script from "./Account.vue?vue&type=script&lang=ts"
export * from "./Account.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Settings/Account.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "82d55638"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('82d55638', __exports__)) {
    api.reload('82d55638', __exports__)
  }
  
  module.hot.accept("./Account.vue?vue&type=template&id=82d55638&ts=true", () => {
    api.rerender('82d55638', render)
  })

}


export default __exports__